import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import {
  Table,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import ApproveModal from "../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";

import "nouislider/distribute/nouislider.css";
import Dropzone from "react-dropzone";
import Flatpickr from "react-flatpickr";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { api } from "../../config";
import FormData from "form-data";
import { useSelector, useDispatch } from "react-redux";

import { resetCompanyState, getCompany } from "../../store/company/action";
import {
  getDepartment,
  resetDepartmentState,
} from "../../store/department/action";
import {
  resetProductCategoryState,
  getProductCategory,
} from "../../store/productCategory/action";
import { getProductTag, addNewProductTag } from "../../store/productTag/action";
import { getUom, addNewUom } from "../../store/uom/action";
import {
  getBrand,
  addNewBrand,
  resetBrandState,
} from "../../store/brand/action";
import {
  getAccAccount,
  resetAccAccountState,
} from "../../store/accAccount/action";
import { deleteFile } from "../../store/file/action";
import {
  resetProductVarianState,
  getProductVarian as onGetProductVarians,
  addNewProductVarian as onAddNewProductVarian,
  updateProductVarian as onUpdateProductVarian,
  deleteProductVarian as onDeleteProductVarian,
  getProductVarianLoading,
  resetProductVarianCreateState,
} from "../../store/productVarian/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import defaultImg from "../../assets/images/upload.png";
SwiperCore.use([FreeMode, Navigation, Thumbs]);

const ProductVarian = () => {
  const [modal, setModal] = useState(false);
  const [modalTag, setModalTag] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [customActiveTab, setCustomActiveTab] = useState("1");

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
    }
  };
  const dispatch = useDispatch();

  const {
    productVarians,
    productVarianAdded,
    isProductVarianCreated,
    isProductVarianSuccess,
    loading,
    error,
    productCategories,
    productCategoryLoading,
    productTags,
    productTagLoading,
    companies,
    companyLoading,
    departments,
    departmentLoading,
    uoms,
    uomLoading,
    brands,
    brandLoading,
  } = useSelector((state) => ({
    productVarianAdded: state.ProductVarian.productVarianAdded,
    productVarians: state.ProductVarian.productVarians,
    isProductVarianCreated: state.ProductVarian.isProductVarianCreated,
    isProductVarianSuccess: state.ProductVarian.isProductVarianSuccess,
    loading: state.ProductVarian.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    productCategories: state.ProductCategory.productCategories,
    productCategoryLoading: state.ProductCategory.loading,
    productTags: state.ProductTag.productTags,
    productTagLoading: state.ProductTag.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    brands: state.Brand.brands,
    brandLoading: state.Brand.loading,
    uoms: state.Uom.uoms,
    uomLoading: state.Uom.loading,
    error: state.ProductVarian.error,
  }));

  const [productVarianList, setProductVarianList] = useState([]);
  const [productVarian, setProductVarian] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [productTagList, setProductTagList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredProductVarians = productVarians;
      if (type !== "all") {
        filteredProductVarians = productVarians.filter(
          (productVarian) => productVarian.pvar_status.name === type
        );
      }
      setProductVarianList(filteredProductVarians);
    }
  };

  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [swiperActiveTab, setSwiperActiveTab] = useState("1");
  const toggleSwiper = (tab) => {
    if (swiperActiveTab !== tab) {
      setSwiperActiveTab(tab);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setProductVarianList(productVarians);
  }, [productVarians]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetProductVarianState());
      dispatch(onGetProductVarians());
      setIsSearch(true);
      setIsEdit(false);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setUserData(obj.data);
        if (obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method) {
          setRoles(obj?.data?.user?.user_position?.position_role.method);
        }
      }
      if (obj?.data) setUserType(obj?.data?.userType);
    }
  }, [dispatch, productVarians, isSearch]);

  useEffect(() => {
    setProductVarian(productVarianAdded);
  }, [productVarianAdded]);

  useEffect(() => {
    if (!isEmpty(productVarianAdded)) {
      setProductVarian(productVarianAdded);
    }
  }, [productVarianAdded]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      setProductVarianList(productVarians);
      setInfo(productVarians[productVarians.length - 1]);
    }
  }, [productVarians]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  useEffect(() => {
    if (companies && !companies.length) {
      dispatch(resetCompanyState());
      dispatch(getCompany());
    }
  }, [dispatch, companies]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (productTags && !productTags.length && !isSearch) {
      dispatch(getProductTag());
    }
  }, [dispatch, productTags, isSearch]);

  useEffect(() => {
    if (!isEmpty(productTags)) {
      var data = [];
      var opt = [];
      productTags.forEach((item, key) => {
        const tag_name = item.tag_name;
        const id = item.id;
        var obj = { label: tag_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setProductTagList(data);
    }
  }, [productTags]);

  useEffect(() => {
    if (uoms && !uoms.length && !isSearch) {
      dispatch(getUom());
    }
  }, [dispatch, uoms, isSearch]);

  useEffect(() => {
    if (!isEmpty(uoms)) {
      var data = [];
      var opt = [];
      uoms.forEach((item, key) => {
        const uom_name = item.uom_name;
        const id = item.id;
        var obj = { label: uom_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setUomList(data);
    }
  }, [uoms]);

  useEffect(() => {
    if (productCategories && !productCategories.length && !isSearch) {
      dispatch(resetProductCategoryState());
      dispatch(getProductCategory());
    }
  }, [dispatch, productCategories, isSearch]);

  useEffect(() => {
    if (!isEmpty(productCategories)) {
      var data = [];
      var opt = [];
      productCategories.forEach((item, key) => {
        const category_name = item.category_name;
        const id = item.id;
        var obj = { label: category_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCategoryList(data);
    }
  }, [productCategories]);

  useEffect(() => {
    if (brands && !brands.length && !isSearch) {
      dispatch(resetBrandState());
      dispatch(getBrand({ status: 2 }));
    }
  }, [brands, isSearch, dispatch]);

  useEffect(() => {
    if (!isEmpty(brands)) {
      var brandData = [];
      var opt = [];
      brands.forEach((item, key) => {
        const brand_name = item.brand_name;
        const id = item.id;
        var obj = { label: brand_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      brandData.push(option);
      setBrandList(brandData);
    }
  }, [brands]);

  function handleCompanyClick(companyId) {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId, status: 2 }));
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
    return false;
  }

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  const onClickDelete = (productVarian) => {
    setProductVarian(productVarian);
    setDeleteModal(true);
  };

  const onClickApprove = (productVarian) => {
    setProductVarian(productVarian);
    setApproveModal(true);
  };

  const handleDeleteProductVarian = () => {
    if (productVarian) {
      dispatch(onDeleteProductVarian(productVarian));
      setDeleteModal(false);
    }
  };

  const handleApproveProductVarian = () => {
    if (productVarian) {
      productVarian.setApprove = true;
      dispatch(onUpdateProductVarian(productVarian));
      setApproveModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setProductVarian(null);
      setSelectedFiles([]);
      setOriginalFiles([]);
      setDepartmentList([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleTag = useCallback(() => {
    if (modalTag) {
      setModalTag(false);
    } else {
      setModalTag(true);
    }
  }, [modalTag]);

  const validationTag = useFormik({
    enableReinitialize: true,
    initialValues: {
      tag_name: "",
    },
    validationSchema: Yup.object({
      tag_name: Yup.string().required("Please enter tag name").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(addNewProductTag({ tag_name: values.tag_name }));
      validationTag.resetForm();
      toggleTag();
    },
  });

  const handleProductVarianClick = useCallback((arg) => {
    const productVarian = arg;
    let tag = [];

    if (productVarian.tag && productVarian.tag.length) {
      productVarian.tag.forEach((item) => {
        const tag_name = item.label;
        const id = item.value;
        var obj = { label: tag_name, value: id };
        tag.push(obj);
      });
    }
    let files = [];
    for (const f of productVarian.pvar_file) {
      files.push({ filename: f.filename, originalname: f.originalname })
    }
    setOriginalFiles(files);
    setProductVarian({
      id: productVarian.id,
      pvar_name: productVarian.pvar_name,
      description: productVarian.description,
      price: productVarian.price,
      hasStock: productVarian.hasStock,
      uom: productVarian.pvar_uom && {
        label: productVarian.pvar_uom.uom_name,
        value: productVarian.pvar_uom.id,
      },
      sku: productVarian.sku,
      condition: productVarian.condition && {
        label: productVarian.condition,
        value: productVarian.condition,
      },
      account: productVarian.pvar_acc_account && {
        label: productVarian.pvar_acc_account.account_name,
        value: productVarian.pvar_acc_account.id,
      },
      barcode: productVarian.barcode,
      brand: productVarian.pvar_brand_ext && {
        label: productVarian.pvar_brand_ext.brand_name,
        value: productVarian.pvar_brand_ext.id,
      },
      class: productVarian.pvar_class && {
        label: productVarian.pvar_class.class_name,
        value: productVarian.pvar_class.id,
      },
      company: productVarian.pvar_company &&
        productVarian.pvar_company.name && {
        label: productVarian.pvar_company.name,
        value: productVarian.pvar_company.id,
      },
      department: productVarian.pvar_department &&
        productVarian.pvar_department.name && {
        label: productVarian.pvar_department.name,
        value: productVarian.pvar_department.id,
      },
      category: productVarian.pvar_category &&
        productVarian.pvar_category.category_name && {
        label: productVarian.pvar_category.category_name,
        value: productVarian.pvar_category.id,
      },
      tag: tag,
      status: productVarian.pvar_status && {
        label: productVarian.pvar_status.name,
        value: productVarian.pvar_status.id,
      },
      acquisitionat: productVarian.acquisitionat,
      depreciation: productVarian.depreciation && {
        label: productVarian.depreciation,
        value: productVarian.depreciation,
      },
    });

    setIsEdit(true);
    toggle();
  }, [toggle]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type='checkbox'
            id='checkBoxAll'
            className='form-check-input'
            onClick={() => checkedAll()} />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type='checkbox'
              className='dataCheckbox form-check-input'
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className='hstack gap-2 mt-4 mt-sm-0'>
              {/* <Link
                to='#'
                className={
                  userType === "admin"
                    ? "btn-icon btn btn-sm btn-light edit-item-btn"
                    : userRole &&
                      userRole.split(",").indexOf("updateProductDetail") !== -1
                      ? "btn-icon btn btn-sm btn-light edit-item-btn"
                      : "btn-icon btn btn-sm btn-light edit-item-btn d-none"
                }
                onClick={() => {
                  let data = cellProps.row.original;
                  handleProductVarianClick(data);
                }}>
                <i className='ri-edit-2-line fs-15'></i>
              </Link> */}
              <Link
                to='#'
                className={
                  userType === "admin"
                    ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                    : userRole &&
                      userRole.split(",").indexOf("deleteProductDetail") !== -1
                      ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                      : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"
                }
                onClick={() => {
                  let data = cellProps.row.original;
                  onClickDelete(data);
                }}>
                <i className='ri-delete-bin-line fs-15 text-danger'></i>
              </Link>

              {cellProps.row.original.statusId === 1 ? (
                <button
                  className={
                    userType === "admin"
                      ? "btn-label btn btn-sm btn-soft-success fs-12 me-0"
                      : userRole &&
                        userRole.split(",").indexOf("approveProductDetail") !== -1
                        ? "btn-label btn btn-sm btn-soft-success fs-12 me-0"
                        : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"
                  }
                  onClick={() => {
                    let data = cellProps.row.original;
                    onClickApprove(data);
                  }}>

                  <i className='ri-checkbox-circle-line label-icon align-middle fs-16 me-1'></i>
                  Approve
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        Header: "Product Varian",
        accessor: "pvar_product.name",
        filterable: true,
        Cell: (data) => {
          return (
            <>
              <div className='d-flex align-items-center'>
                <div className='flex-shrink-0 me-3'>
                  <div className='avatar-sm bg-light rounded p-1'>
                    {data.row.original.image && (
                      <img
                        src={
                          data.row.original.image === ""
                            ? defaultImg
                            : `${api.MEDIA_URL}/media/${data.row.original.image}`
                        }
                        alt=''
                        className='img-fluid d-block'
                        style={{ height: "45px" }}
                      />
                    )}
                  </div>
                </div>
                <div className='flex-grow-1'>
                  <h5 className='fs-14 mb-1'>
                    {data.row.original.pvar_product.name}
                  </h5>
                  <p className='text-muted mb-0'>
                    <span className='fw-medium'>
                      {data.row.original.pvar_product.product_category &&
                        data.row.original.pvar_product.product_category.name}
                    </span>
                  </p>
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: "Warna",
        accessor: "pvar_option_detail.name",
        filterable: true,
        Cell: (data) => {
          var colors;
          data.row.original.pvar_options.forEach((item) => {
            if (item.isColor) {
              colors = item;
            }
          });
          return (
            <>
              <button
                type='button'
                className='btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-20'
                disabled
                style={{
                  color:
                    colors && colors.pvar_option_detail && colors.pvar_option_detail.color
                      ? colors.pvar_option_detail.color
                      : "",
                  marginTop: "-5px",
                }}>
                <i className='ri-checkbox-blank-circle-fill'></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Category",
        accessor: "pvar_product.product_category.name",
        filterable: true,
      },
      {
        Header: "Barcode",
        accessor: "barcode",
        filterable: true,
      },
      {
        Header: "SKU",
        accessor: "sku",
        filterable: true,
      },
      {
        Header: "Stock",
        accessor: "stocks",
        filterable: true,
        Cell: (data) => {
          return <span>{Math.round(data.row.original.stocks, 0)}</span>;
        },
      },
      {
        Header: "Price",
        accessor: "price",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.price)}</span>;
        },
      },
      {
        Header: "Orders",
        accessor: "orders",
        filterable: true,
        Cell: (data) => {
          return <span>{Math.round(data.row.original.orders, 0)}</span>;
        },
      },
      {
        Header: "Status",
        accessor: "pvar_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return (
                <span className='badge text-uppercase badge-soft-warning'>

                  {cell.value}
                </span>
              );
            case "ACTIVE":
              return (
                <span className='badge text-uppercase badge-soft-info'>

                  {cell.value}
                </span>
              );
            case "INACTIVE":
              return (
                <span className='badge text-uppercase badge-soft-danger'>

                  {cell.value}
                </span>
              );
            default:
              return (
                <span className='badge text-uppercase badge-soft-warning'>

                  {cell.value}
                </span>
              );
          }
        },
      },
    ], [userRole, userType]);

  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: productVarianList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetProductVarians(param));
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (productVarian && productVarian.id) || 0,
      pvar_name: (productVarian && productVarian.pvar_name) ?? "",
      description: (productVarian && productVarian.description) ?? "",
      price: (productVarian && productVarian.price) || 0,
      sku: (productVarian && productVarian.sku) ?? "",
      hasStock: (productVarian && productVarian.hasStock) || false,
      barcode: (productVarian && productVarian.barcode) ?? "",
      brand: productVarian && productVarian.brand,
      department: productVarian && productVarian.department,
      company: productVarian && productVarian.company,
      category: productVarian && productVarian.category,
      uom: productVarian && productVarian.uom,
      account: productVarian && productVarian.account,
      class: productVarian && productVarian.class,
      tag: productVarian && productVarian.tag,
      status: productVarian && productVarian.status,
      pvar_holder: productVarian && productVarian.pvar_holder,
      condition: productVarian && productVarian.condition,
      acquisitionat: productVarian && productVarian.acquisitionat,
      depreciation: productVarian && productVarian.depreciation,
    },
    validationSchema: Yup.object({
      pvar_name: Yup.string()
        .required("Please enter productVarian name")
        .nullable(true),
      brand: Yup.object().required("Please enter brand name").nullable(true),
      uom: Yup.object().required("Please enter unit").nullable(true),
      class: Yup.object().required("Please enter class").nullable(true),
      price: Yup.number().required("Please enter price number").nullable(true),
      sku: Yup.string().required("Please enter sku").nullable(true),
      barcode: Yup.string().required("Please enter barcode").nullable(true),
      company: Yup.object().required("Please enter company").nullable(true),
      condition: Yup.object()
        .required("Please enter productVarian condition")
        .nullable(true),
      department: Yup.object()
        .required("Please enter department")
        .nullable(true),
      category: Yup.object().required("Please enter category").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getProductVarianLoading());
      if (isEdit) {
        let formData = new FormData();
        if (values.files && values.files.length) {
          for (let i = 0; i < values.files.length; i++) {
            formData.append("files", values.files[i]);
          }
        }
        formData.append("id", values.id);
        formData.append("pvar_name", values.pvar_name);
        formData.append("brand", values.brand.value);
        formData.append("description", values.description);
        formData.append("uom", values.uom.value);
        formData.append("classId", values.class.value);
        formData.append("acquisitionat", values.acquisitionat);
        formData.append("depreciation", values.depreciation.value);
        formData.append("sku", values.sku);
        formData.append("barcode", values.barcode);
        formData.append("price", values.price);
        formData.append("hasStock", values.hasStock);
        formData.append("statusId", values.status && values.status.value);
        formData.append("categoryId", values.category && values.category.value);
        formData.append("companyId", values.company && values.company.value);
        formData.append(
          "departmentId",
          values.department && values.department.value
        );
        formData.append("accId", values.account.value);
        formData.append("tag", JSON.stringify(values.tag));
        formData.append("pvar_holder", JSON.stringify(values.pvar_holder));
        formData.append("condition", values.condition.value);
        dispatch(onUpdateProductVarian(formData));
      } else {
        let formData = new FormData();
        if (values.files && values.files.length) {
          for (let i = 0; i < values.files.length; i++) {
            formData.append("files", values.files[i]);
          }
        }
        formData.append("pvar_name", values.pvar_name);
        formData.append("brand", values.brand.value);
        formData.append("description", values.description);
        formData.append("uom", values.uom.value);
        formData.append("classId", values.class.value);
        formData.append("sku", values.sku);
        formData.append("barcode", values.barcode);
        formData.append("price", values.price);
        formData.append("acquisitionat", values.acquisitionat);
        formData.append("depreciation", values.depreciation.value);
        formData.append("hasStock", values.hasStock);
        formData.append("statusId", values.status && values.status.value);
        formData.append("categoryId", values.category && values.category.value);
        formData.append("companyId", values.company && values.company.value);
        formData.append(
          "departmentId",
          values.department && values.department.value
        );
        formData.append("accId", values.account.value);
        formData.append("tag", JSON.stringify(values.tag));
        formData.append("pvar_holder", JSON.stringify(values.pvar_holder));
        formData.append("condition", values.condition.value);
        dispatch(onAddNewProductVarian(formData));
      }
      validation.resetForm();
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteProductVarian(element.value));
    });
    checkall.checked = false;
  };

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles(files);
    validation.setFieldValue("files", files);
  }

  function handleDeleteFiles(filesId) {
    const object = originalFiles.findIndex((obj) => obj.id === filesId);
    if (object > -1) {
      dispatch(deleteFile({ id: filesId }));
      originalFiles.splice(object, 1);
    }
  }

  function handleDeleteUploadedFiles(filesId) {
    const object = selectedFiles.findIndex((obj, idx) => idx === filesId);
    if (object > -1) selectedFiles.splice(object, 1);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  document.title = "ProductVarians | Enterprise Resources Planning";

  return (
    <div className='page-content'>
      <ExportCSVModal
        show={isExportCSV}
        onCloseClick={() => setIsExportCSV(false)}
        data={productVarianList} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProductVarian}
        onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal
        data={
          productVarian && productVarian.pvar_name
            ? productVarian.pvar_name
            : ""
        }
        show={approveModal}
        onApproveClick={handleApproveProductVarian}
        onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title='Product Detail' pageTitle='ProductVarian' />
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className='card-header border-0'>
                <div className='d-flex align-items-center'>
                  <h5 className='card-title mb-0 flex-grow-1'>
                    Product Detail &nbsp;
                    {isLoading && (
                      <>
                        <Spinner color='primary' type='grow' size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color='success' type='grow' size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className='flex-shrink-0'>
                    {/* <button
                      type='button'
                      className={
                        userType === "admin"
                          ? "btn btn-primary add-btn me-2"
                          : userRole &&
                            userRole.split(",").indexOf("createProductDetail") !==
                            -1
                            ? "btn btn-primary add-btn me-2"
                            : "btn btn-primary add-btn me-2 d-none"
                      }
                      id='create-btn'
                      onClick={() => {
                        setProductVarian("");
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className='ri-archive-line me-1 align-bottom fs-14'></i>Tambah
                    </button>  */}
                    <button
                      type='button'
                      className='btn btn-success'
                      onClick={() => setIsExportCSV(true)}>
                      <i className='ri-file-download-line me-1 align-bottom fs-14'></i>Export
                    </button>
                    <button
                      className='btn btn-soft-danger'
                      onClick={() => setDeleteModalMulti(true)}>
                      <i className='ri-delete-bin-5-line me-1 align-bottom fs-15'></i>Delete
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className='pt-0'>
                <div>
                  <Nav
                    className='nav-tabs nav-tabs-custom nav-success'
                    role='tablist'>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "1" },
                          "fw-semibold"
                        )} onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href='#'>
                        <i className='ri-store-line me-1 align-bottom fs-14'></i>ALL VARIAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "2" },
                          "fw-semibold"
                        )} onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href='#'>
                        <i className='ri-information-line me-1 align-bottom fs-14'></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "3" },
                          "fw-semibold"
                        )} onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href='#'>
                        <i className='ri-checkbox-circle-line me-1 align-bottom fs-14'></i>ACTIVE</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "4" },
                          "fw-semibold"
                        )} onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href='#'>
                        <i className='ri-indeterminate-circle-line me-1 align-bottom fs-14'></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className='mb-3'>
                    <CardBody className='border border-top-0 border-end-0 border-start-0'>
                      <form>
                        <Row>
                          <Col sm={2} className='col-xxl-2'>
                            <div className='me-2 mb-3 col-12'>
                              <select
                                className='form-select'
                                value={pageSize}
                                onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className='search-box me-2 mb-3 d-inline-block col-12'>
                              <input
                                id='search-bar-0'
                                type='text'
                                className='form-control search'
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""} /><i className='bx bx-search-alt search-icon'></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type='button'
                                className='btn btn-light w-100'
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className='ri-search-line me-1 align-bottom fs-14'></i>        Search
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className='table-responsive table-card mb-1'>
                    <Table
                      hover
                      {...getTableProps()}
                      className='align-middle table-nowrap'>
                      <thead className='table-light'>
                        {headerGroups.map((headerGroup, index) => (
                          <tr
                            {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th
                                {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className='justify-content-md-end justify-content-center align-items-center p-2'>
                    <Col className='col-md-auto'>
                      <div className='d-flex gap-1'>
                        <Button
                          className='btn btn-light'
                          onClick={previousPage}
                          disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className='col-md-auto d-none d-md-block'>
                      Page{pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className='col-md-auto'>
                      <Input
                        type='number'
                        min={1}
                        style={{ width: 70 }}
                        max={pageOptions.length}
                        defaultValue={pageIndex + 1}
                        onChange={onChangeInInput}
                      />
                    </Col>
                    <Col className='col-md-auto'>
                      <div className='d-flex gap-1'>
                        <Button
                          className='btn btn-light'
                          onClick={nextPage}
                          disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id='showModal' isOpen={modal} centered size='xl'>
                  <ModalHeader className='bg-light p-3' toggle={toggle}>
                    {!!isEdit ? "Edit ProductVarian" : "Add ProductVarian"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <Row>
                        <Col lg={8}>
                          <div className='mb-3'>
                            <Label className='form-label' htmlFor='pvar_name'>
                              ProductVarian Title    </Label>
                            <Input
                              type='text'
                              className='form-control'
                              id='pvar_name'
                              placeholder='Enter productVarian title'
                              name='pvar_name'
                              value={validation.values.pvar_name ?? ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={
                                validation.touched.pvar_name &&
                                  validation.errors.pvar_name
                                  ? true
                                  : false
                              } />
                            {validation.touched.pvar_name &&
                              validation.errors.pvar_name && (
                                <small className='text-danger' type='invalid'>
                                  {validation.errors.pvar_name}
                                </small>
                              )}
                          </div>
                          <div className='mb-3'>
                            <Label>ProductVarian Description</Label>
                            <Input
                              type='textarea'
                              className='form-control'
                              id='description'
                              placeholder='Enter description title'
                              name='description'
                              rows={4}
                              value={validation.values.description ?? ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={
                                validation.touched.description &&
                                  validation.errors.description
                                  ? true
                                  : false
                              } />
                            {validation.touched.description &&
                              validation.errors.description && (
                                <small className='text-danger' type='invalid'>
                                  {validation.errors.description}
                                </small>
                              )}
                          </div>
                          <Card>
                            <CardBody className='border-0'>
                              <h5 className='card-title mb-3'>
                                ProductVarian Gallery
                              </h5>
                              <div>
                                <Dropzone
                                  onDrop={(acceptedFiles) => {
                                    handleAcceptedFiles(acceptedFiles);
                                  }}>
                                  {({ getRootProps, getInputProps }) => (
                                    <div
                                      className='dropzone dz-clickable'
                                      style={{
                                        cursor: "pointer",
                                        height: "140px",
                                      }}
                                      {...getRootProps({
                                        className: "dropzone",
                                      })}>
                                      <div className='dz-message needsclick'>
                                        <div>
                                          <i className='display-4 text-muted ri-upload-cloud-2-fill' />
                                          <input {...getInputProps()} />
                                        </div>
                                        <h5>
                                          Drop files here or click to upload.
                                        </h5>
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>
                                <div
                                  className='list-unstyled mb-0'
                                  id='file-previews'>
                                  {originalFiles.map((f, i) => {
                                    if (f.statusId !== 3) {
                                      return (
                                        <Card
                                          className='mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete'
                                          key={i + "-file"}>
                                          <div className='p-2 d-flex align-items-center'>
                                            <Row className='flex-grow-1'>
                                              <Col className='col-auto'>
                                                {f.mimetype.includes(
                                                  "image"
                                                ) ? (
                                                  <img
                                                    data-dz-thumbnail=''
                                                    height='80'
                                                    className='avatar-sm rounded bg-light'
                                                    alt={f.filename}
                                                    src={
                                                      process.env
                                                        .REACT_APP_API_URL +
                                                      "/files/" +
                                                      f.path
                                                    }
                                                  />
                                                ) : (
                                                  <i className='display-6 text-muted ri-function-line' />
                                                )}
                                              </Col>
                                              <Col className='overflow-scroll'>
                                                <Link
                                                  to='#'
                                                  className='text-muted font-weight-bold'>
                                                  {f.originalname}                        </Link>
                                                <p className='mb-0'>
                                                  <strong>
                                                    {formatBytes(f.size)}
                                                  </strong>
                                                </p>
                                              </Col>
                                            </Row>
                                            <Link
                                              to='#'
                                              className='text-danger btn-icon btn btn-sm btn-soft-danger flex-shrink-0'
                                              onClick={() => {
                                                handleDeleteFiles(f.id);
                                              }}>
                                              <i className='ri-delete-bin-line fs-15 text-danger'></i>
                                            </Link>
                                          </div>
                                        </Card>
                                      );
                                    } else return null;
                                  })}
                                  {selectedFiles.map((f, i) => {
                                    return (
                                      <Card
                                        className='mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete'
                                        key={i + "-file"}>
                                        <div className='p-2 d-flex align-items-center'>
                                          <Row className='flex-grow-1'>
                                            <Col className='col-auto'>
                                              <img
                                                data-dz-thumbnail=''
                                                height='80'
                                                className='avatar-sm rounded bg-light'
                                                alt={f.name}
                                                src={f.preview}
                                              />
                                            </Col>
                                            <Col>
                                              <Link
                                                to='#'
                                                className='text-muted font-weight-bold'>
                                                {f.name}                      </Link>
                                              <p className='mb-0'>
                                                <strong>
                                                  {f.formattedSize}
                                                </strong>
                                              </p>
                                            </Col>
                                          </Row>
                                          <Link
                                            to='#'
                                            className='text-danger btn-icon btn btn-sm btn-soft-danger flex-shrink-0'
                                            onClick={() => {
                                              handleDeleteUploadedFiles(i);
                                            }}>
                                            <i className='ri-delete-bin-line fs-15 text-danger'></i>
                                          </Link>
                                        </div>
                                      </Card>
                                    );
                                  })}
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardBody>
                              <h5 className='card-title mb-4'>
                                ProductVarian Detail
                              </h5>
                              <Row>
                                <Col sm={6}>
                                  <div className='mb-3'>
                                    <label
                                      className='form-label'
                                      htmlFor='price'>
                                      ProductVarian acquisition value            </label>
                                    <div className='input-group mb-3'>
                                      <span
                                        className='input-group-text'
                                        id='price-addon'>
                                        Rp
                                      </span>
                                      <Input
                                        type='number'
                                        className='form-control'
                                        id='price'
                                        placeholder='Enter price'
                                        name='price'
                                        value={validation.values.price || 0}
                                        onBlur={validation.handleBlur}
                                        onChange={validation.handleChange}
                                        invalid={
                                          validation.touched.price &&
                                            validation.errors.price
                                            ? true
                                            : false
                                        }
                                      />
                                      {validation.touched.price &&
                                        validation.errors.price && (
                                          <small
                                            className='text-danger'
                                            type='invalid'>
                                            {validation.errors.price}
                                          </small>
                                        )}
                                    </div>
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className='mb-3'>
                                    <label
                                      className='form-label'
                                      htmlFor='weight'>
                                      Unit of Measure
                                    </label>
                                    <Select
                                      name='uom'
                                      placeholder='Enter unit'
                                      value={validation.values.uom}
                                      onChange={(e) => {
                                        validation.setFieldValue("uom", e);
                                      }}
                                      options={uomList}></Select>
                                    {validation.touched.uom &&
                                      validation.errors.uom && (
                                        <small
                                          className='text-danger'
                                          type='invalid'>
                                          {validation.errors.uom}
                                        </small>
                                      )}
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className='mb-3'>
                                    <label className='form-label' htmlFor='sku'>
                                      SKU            </label>
                                    <Input
                                      name='sku'
                                      id='sku'
                                      className='form-control'
                                      placeholder='Enter sku'
                                      type='text'
                                      value={validation.values.sku}
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      invalid={
                                        validation.touched.sku &&
                                          validation.errors.sku
                                          ? true
                                          : false
                                      } />
                                    {validation.touched.sku &&
                                      validation.errors.sku && (
                                        <small
                                          className='text-danger'
                                          type='invalid'>
                                          {validation.errors.sku}
                                        </small>
                                      )}
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className='mb-3'>
                                    <label
                                      className='form-label'
                                      htmlFor='barcode'>
                                      Barcode            </label>
                                    <Input
                                      name='barcode'
                                      id='barcode'
                                      className='form-control'
                                      placeholder='Enter barcode'
                                      type='text'
                                      value={validation.values.barcode}
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      invalid={
                                        validation.touched.barcode &&
                                          validation.errors.barcode
                                          ? true
                                          : false
                                      } />
                                    {validation.touched.barcode &&
                                      validation.errors.barcode && (
                                        <small
                                          className='text-danger'
                                          type='invalid'>
                                          {validation.errors.barcode}
                                        </small>
                                      )}
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className='mb-3'>
                                    <label className='mb-2'>
                                      ProductVarian Category
                                    </label>
                                    <Select
                                      name='category'
                                      value={validation.values.category}
                                      placeholder='Select category'
                                      onChange={(e) => {
                                        validation.setFieldValue("category", e);
                                      }}
                                      options={categoryList}></Select>
                                    {validation.touched.category &&
                                      validation.errors.category && (
                                        <small
                                          className='text-danger'
                                          type='invalid'>
                                          {validation.errors.category}
                                        </small>
                                      )}
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className='mb-3'>
                                    <label
                                      className='form-label'
                                      htmlFor='brand'>
                                      Brand
                                    </label>
                                    <Select
                                      name='brand'
                                      value={validation.values.brand}
                                      placeholder='Enter brand'
                                      onChange={(e) => {
                                        validation.setFieldValue("brand", e);
                                      }}
                                      options={brandList}></Select>
                                    {validation.touched.brand &&
                                      validation.errors.brand && (
                                        <small
                                          className='text-danger'
                                          type='invalid'>
                                          {validation.errors.brand}
                                        </small>
                                      )}
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className='mb-3'>
                                    <p className='mb-0'>
                                      <Link
                                        to='#'
                                        className='float-end text-decoration-underline'
                                        onClick={() => toggleTag()}>
                                        Tambah
                                      </Link>              <label>ProductVarian Tag</label>
                                    </p>
                                    <Select
                                      name='tag'
                                      value={validation.values.tag}
                                      placeholder='Select productVarian tag'
                                      isMulti
                                      onChange={(opt, { option }) => {
                                        let newOpts = opt;
                                        if (option && option.value === "all") {
                                          let filteredOptions =
                                            clone(productTagList);
                                          filteredOptions =
                                            filteredOptions[0].options.filter(
                                              (filteredOption) =>
                                                !newOpts.includes(
                                                  filteredOption
                                                )
                                            );
                                          newOpts = newOpts
                                            .concat(filteredOptions)
                                            .filter(
                                              (newOpt) => newOpt.value !== "all"
                                            );
                                        }
                                        validation.setFieldValue(
                                          "tag",
                                          newOpts
                                        );
                                      }}
                                      options={productTagList}></Select>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col lg={4}>
                          <Card>
                            <CardHeader className='bg-light ps-3 pe-3 pt-3 pb-2'>
                              <h5 className='card-title mb-0'>
                                ProductVarian Identity & Status
                              </h5>
                            </CardHeader>
                            <CardBody className='row'>
                              <div className='mb-3'>
                                <label className='form-label' htmlFor='company'>
                                  Company
                                </label>
                                <Select
                                  name='company'
                                  value={validation.values.company}
                                  placeholder='Enter company'
                                  onChange={(e) => {
                                    validation.setFieldValue("company", e);
                                    handleCompanyClick(e.value);
                                  }}
                                  options={companyList}></Select>
                                {validation.touched.company &&
                                  validation.errors.company && (
                                    <small
                                      className='text-danger'
                                      type='invalid'>
                                      {validation.errors.company}
                                    </small>
                                  )}
                              </div>
                              <div className='mb-3'>
                                <Label
                                  htmlFor='department'
                                  className='form-label'>
                                  Department / Cost Center
                                  {departmentLoading ? (
                                    <Spinner color='primary' size='sm'>
                                      Loading...
                                    </Spinner>
                                  ) : (
                                    ""
                                  )}
                                </Label>
                                <Select
                                  name='department'
                                  value={validation.values.department}
                                  placeholder='Enter Department'
                                  onChange={(e) => {
                                    validation.setFieldValue("department", e);
                                  }}
                                  options={departmentList}
                                  invalid={
                                    validation.touched.department &&
                                      validation.errors.department
                                      ? true
                                      : false
                                  }></Select>
                                {validation.touched.department &&
                                  validation.errors.department ? (
                                  <small className='text-danger' type='invalid'>
                                    {validation.errors.department}
                                  </small>
                                ) : null}
                              </div>
                              <div className='mb-1'>
                                <Input
                                  name='hasStock'
                                  id='hasStock-field'
                                  className='form-check-input'
                                  type='checkbox'
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  checked={validation.values.hasStock}
                                />        &nbsp;
                                <Label
                                  htmlFor='hasStock-field'
                                  className='form-label'>
                                  Has Stock
                                </Label>
                              </div>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardHeader className='bg-light ps-3 pe-3 pt-3 pb-2'>
                              <h5 className='card-title mb-0'>Accounting</h5>
                            </CardHeader>
                            <CardBody className='row'>
                              <div className='mb-3'>
                                <label
                                  htmlFor='datepicker-publish-input'
                                  className='form-label'>
                                  Acquisition Date
                                </label>
                                <Flatpickr
                                  name='date-picker'
                                  className='form-control'
                                  placeholder='Select acquisition date'
                                  options={{
                                    enableTime: false,
                                    time_24hr: false,
                                    dateFormat: "Y/m/d",
                                  }}
                                  value={validation.values.acquisitionat ?? ""}
                                  onChange={(obj, str) => {
                                    validation.setFieldValue(
                                      "acquisitionat",
                                      str
                                    );
                                  }}
                                />
                                {validation.touched.acquisitionat &&
                                  validation.errors.acquisitionat && (
                                    <small
                                      className='text-danger'
                                      type='invalid'>
                                      {validation.errors.acquisitionat}
                                    </small>
                                  )}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                    <div className='modal-footer'>
                      <div className='hstack gap-2 justify-content-end'>
                        <button
                          type='button'
                          className='btn btn-light'
                          onClick={() => {
                            setModal(false);
                          }}>
                          Close
                        </button>
                        <button
                          type='submit'
                          className='btn btn-success'
                          disabled={loading}>
                          <span className='d-flex align-items-center'>
                            {!!isEdit ? "Update" : "Add ProductVarian"}
                            {loading ? (
                              <Spinner
                                size='sm'
                                className='flex-shrink-0'
                                role='status'>
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id='showModalTag' isOpen={modalTag} centered size='md'>
                  <ModalHeader className='bg-light p-3' toggle={toggleTag}>
                    Add ProductVarian Tag
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationTag.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className='row'>
                        <div className='mb-3 col-lg-12'>
                          <Label
                            htmlFor='tag_name-field'
                            className='form-label'>
                            Tag Name
                          </Label>
                          <Input
                            name='tag_name'
                            id='tag_name-field'
                            className='form-control'
                            placeholder='Enter Tag Name'
                            type='text'
                            onChange={validationTag.handleChange}
                            onBlur={validationTag.handleBlur}
                            invalid={
                              validationTag.touched.tag_name &&
                                validationTag.errors.tag_name
                                ? true
                                : false
                            } />
                          {validationTag.touched.tag_name &&
                            validationTag.errors.tag_name ? (
                            <FormFeedback type='invalid'>
                              {validationTag.errors.tag_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className='modal-footer'>
                      <div className='hstack gap-2 justify-content-end'>
                        <button
                          type='button'
                          className='btn btn-light'
                          onClick={() => {
                            setModalTag(false);
                          }}>
                          Close
                        </button>
                        <button type='submit' className='btn btn-success'>
                          <span className='d-flex align-items-center'>
                            <span className='flex-grow-1 me-2'>
                              Add ProductVarian Tag
                            </span>
                            {loading ? (
                              <Spinner
                                size='sm'
                                className='flex-shrink-0'
                                role='status'>
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>


              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductVarian;
